import { render } from "./FirstSection.vue?vue&type=template&id=7c9c85ac&scoped=true"
import script from "./FirstSection.vue?vue&type=script&lang=ts"
export * from "./FirstSection.vue?vue&type=script&lang=ts"

import "./FirstSection.vue?vue&type=style&index=0&id=7c9c85ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c9c85ac"

export default script